import * as R from 'ramda';

import generator from "../../hor/module";
import fetchWithView from "../../utils/fetchWithView";

const {
  reducer,
  fetch,
} = generator({
  name: 'Requests_Main',
  tableId: 219,
  parseItem: R.compose(
    R.evolve({
      custom_вопрос: R.defaultTo(''),
      ___modifieddate: R.identity,
    }),
    item => R.pipe(
      R.dissoc('___modifieddate'),
      R.assoc('modifiedDate', item.___modifieddate)
    )(item)
  ),
})

export {
  fetch,
}

export {
  getClientMainRequestsSelector
} from './selectors'

export const fetchMainClientRequests = fetchWithView(fetch, '_for_dashboard');

export default reducer;